/**
 * Removes item from array if it exists.
 *
 * @export
 * @param {Array<T>} array
 * @param {*} item
 * @returns {T[]}
 */
export function removeFromArray<T>(array: T[], item: T): T[] {
	// Copy array before modifying to ensure it doesn't change.
	const origArray = array.slice(0);
	const index = origArray.indexOf(item);

	if (index > -1) {
		origArray.splice(index, 1);
	}

	return origArray;
}
